import { createStandardAction } from 'typesafe-actions';

import type { UserAgent } from 'UserAgent-Types';

export const setUserAgent = createStandardAction('SET_USER_AGENT')<UserAgent>();
